import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {getUrlParameters} from '../../common/util/urlParameters';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const restoreDealerEmergingOrdersPage = () => ({
  'type': ActionTypes.RESTORE_DEALER_EMERGING_ORDERS_PAGE,
});

export const toggleCreatedDealerEmergingOrder = () => ({
  'type': ActionTypes.TOGGLE_CREATED_DEALER_EMERGING_MODAL,
});

export const selectDealerEmergingOrderCode = (partCode) => ({
  'type': ActionTypes.SELECT_DEALER_EMERGING_ORDER_CODE,
  'payload': partCode,
});

export const updateDealerEmergingOrderValue = (field, value) => ({
  'type': ActionTypes.UPDATE_DEALER_EMERGING_ORDER_VALUE,
  'payload': {field, value},
});

export const saveDealerLostSale = (data) => apiActionCreator({
  'endpoint': '/orders/dealers/emergent',
  'authenticated': true,
  'types': [
    ActionTypes.SAVE_DEALER_LOST_SALE_REQUEST,
    ActionTypes.SAVE_DEALER_LOST_SALE_SUCCESS,
    [
      ActionTypes.SAVE_DEALER_LOST_SALE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'PATCH',
  'contentType': 'application/json',
  'data': data,
});

export const searchDealerEmergingOrder = (partCode, quantity) => apiActionCreator({
  'endpoint': `/orders/dealers/emergent${getUrlParameters({partCode, quantity})}`,
  'authenticated': true,
  'types': [
    ActionTypes.SEARCH_DEALER_EMERGING_ORDER_REQUEST,
    [
      ActionTypes.SEARCH_DEALER_EMERGING_ORDER_SUCCESS,
    ],
    [
      ActionTypes.SEARCH_DEALER_EMERGING_ORDER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const createDealerEmergingOrder = (data, mainCode) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/orders/dealers/emergent',
      'authenticated': true,
      'types': [
        ActionTypes.CREATE_DEALER_EMERGING_ORDER_REQUEST,
        [
          () => {
            dispatch(searchDealerEmergingOrder(mainCode));
            return {'type': ActionTypes.CREATE_DEALER_EMERGING_ORDER_SUCCESS};
          },
        ],
        [
          ActionTypes.CREATE_DEALER_EMERGING_ORDER_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': data,
    })
  );
};
